import { IClientVars } from '../../../core/interfaces/client-vars.interface';

export function loadOnlineClientVars(): Promise<IClientVars> {
    return new Promise<IClientVars>((resolve) => {
        const { clientVars } = window;
        /**
         * 接口正常返回 collab_client_vars 数据才 resolve
         * data/get 接口失败时：
         * web 端会由网关统一跳空白页
         * 客户端不做处理，等待 offline 模块获取本地数据并 emit clientVarsDataReady 事件
         */
        if (clientVars?.collab_client_vars) {
            resolve(clientVars);
        } else {
            window.addEventListener('clientVarsDataReady', () => {
                resolve(window.clientVars);
            });

            // TODO: 处理 clientVars 加载错误
        }
    });
}
